import type { ReactNode } from 'react'
import { cx } from '../utils/cx'

export function Gallery({ children, className }: { children?: ReactNode; className?: string }) {
  return <div className={cx('st-gallery', className)}>{children}</div>
}
